// :cow: Cosmose CONFIDENTIAL :iso:
import { EnvironmentConfig } from '@med/app/core/config/environment-config';

export const config: EnvironmentConfig = {
  smartLookIntegration: true,
  sentry: false,
  apiUrl: 'https://api.eu.cosmose.co',
  enterpriseApi: 'https://api.eu.cosmose.co/enterprise-api/v1',
  apiDspCampaignService: 'enterprise-dsp-api/v1',
  apiFacebookIntegrator: 'facebook-integrator/v2',
  apiStoreScan: 'store-scan-api/v4',
  securityToken: 'ZW50ZXJwcmlzZS13ZWI6VmFlaTNiaFhVbktlM1J1Vmx3R0I=',
  mapboxToken: 'pk.eyJ1IjoiY29zbW9zZSIsImEiOiJja2JtOGw4bTYxZ2hmMnhsczV0NnA5YjVvIn0.c_lanWto1ySJcmPXCmEx1Q',
  googleAnalytics: 'UA-101159088-3',
  languages: ['en', 'jp'],
  hotjarClientId: 1750109,
  plannerDemoType: 'japan',
  excludedLanguageUrlRegex: 'https://api.eu.cosmose.co/enterprise-api/v1/campaigns/\d+/estimates',
  lockscreenApi: 'https://kaikai-now-admin.sg.cosmose.co/kaikai-now-content-api/v1',
  toggles: {
    showAdvertiserFilter: false
  }
};
